import { faChevronRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, {
  DetailedHTMLProps,
  Dispatch,
  HTMLAttributes,
  ReactNode,
  SetStateAction,
} from 'react';

export interface VoxelMenuProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  menuListItems: MenuItem[];
  selectedId?: any;
  setSelectedId: Dispatch<SetStateAction<any>>;
  disableArrow?: boolean;
}

export interface MenuItem {
  name: string;
  id: any;
  icon?: ReactNode;
  disabled?: boolean;
}

export const VoxelMenu: React.FC<VoxelMenuProps> = ({
  children,
  menuListItems,
  selectedId,
  setSelectedId,
  className,
  disableArrow,
}) => {
  return (
    <ul className={className}>
      {menuListItems.map((listItem, index) => (
        <a
          key={listItem.id}
          onClick={listItem.disabled ? undefined : () => setSelectedId(listItem.id)}
          className={`
              relative min-w-max
              p-3 rounded-lg
              select-none
              flex flex-row items-center gap-2 justify-between
              ${listItem.disabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-voxel-gray-100'}
            `}
        >
          <p
            className={`text-[15px] font-sans
            ${listItem.id === selectedId && 'text-voxel-gray-600 font-bold'}
            ${listItem.id !== selectedId &&
              !listItem.disabled &&
              'text-voxel-gray-500 font-semibold'
              }
            ${listItem.id !== selectedId && listItem.disabled && 'text-voxel-gray-400 font-semibold'
              }
          `}
          >
            {listItem.name}
          </p>
          {!disableArrow && (
            <FontAwesomeIcon
              icon={faChevronRight}
              size="sm"
              className={`  
                  text-voxel-gray-500
                  ${listItem.id === selectedId ? 'block' : 'hidden'}
                  transition ease-in-out delay-150
              `}
            />
          )}
        </a>
      ))}
    </ul>
  );
};

export default VoxelMenu;
